import SpaceDashboardIcon from "@mui/icons-material/SpaceDashboardRounded";
import UploadIcon from "@mui/icons-material/CloudUploadRounded";
import TimelineIcon from "@mui/icons-material/TimelineRounded";
import InsightsIcon from "@mui/icons-material/PsychologyRounded";
import AlertIcon from "@mui/icons-material/NotificationsActiveRounded";
import SettingsIcon from "@mui/icons-material/SettingsRounded";

/** Shared primary nav for sidebar (desktop) and mobile header menu. */
export const DASHBOARD_NAV_ITEMS = [
  { path: "/dashboard", icon: SpaceDashboardIcon, label: "Dashboard" },
  { path: "/upload", icon: UploadIcon, label: "Upload Reports" },
  { path: "/timeline", icon: TimelineIcon, label: "Timeline" },
  { path: "/insights", icon: InsightsIcon, label: "AI Insights" },
  { path: "/alerts", icon: AlertIcon, label: "Alerts", badgeFromCount: true },
  { path: "/settings", icon: SettingsIcon, label: "Settings" }
];
